import React, { useContext, useEffect, useState } from "react";
import { profileURL, schoolURL, teacherURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import { useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import useSave from "../../Hooks/useSave";
import Profile from "../../Template/Home/Profile/Profile";
import useFetchWhen from "../../Hooks/useFetchWhen";

function ProfilePage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id } = useParams();

  const page = "profile";

  const [Open, setOpen] = useState(false);
  const [PassOpen, setPassOpen] = useState(false);

  const { data, loading, error } = useFetch(profileURL);
  const [profile, setProfile] = useState({});

  useEffect(() => {
    if (!loading && !error && data) {
      setProfile(data.data);
    }
  }, [data, loading, error]);

  return (
    <Profile
      Open={Open}
      setOpen={setOpen}
      PassOpen={PassOpen}
      setPassOpen={setPassOpen}
      profile={profile}
      setProfile={setProfile}
      contextData={contextData}
      loading={loading}
    />
  );
}

export default ProfilePage;
